import { storage } from './storage'

export const getCompany = () => storage.get('_company_id') || null

export const setCompany = (id: number) => storage.set('_company_id', id)
